import { useAuthStore } from '@features/auth';
import { createFileRoute, Outlet, redirect } from '@tanstack/react-router';
import { Box } from '@mui/material';

export const Route = createFileRoute('/_staff')({
  beforeLoad: async () => {
    const accessToken = useAuthStore.getState().accessToken;
    const isStaff = useAuthStore.getState().isStaff;
    console.log('isStaff', isStaff);
    if (!accessToken || !isStaff) {
      throw redirect({
        to: '/',
      });
    }
  },
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Box
      sx={{
        height: '1000px',
        backgroundColor: '#FFFFFFFF',
      }}
    >
      <Outlet />
    </Box>
  );
}
